export default function MarketingData() {
    return [
        {
            text: [
                {
                    title: "What is whole life insurance?",
                    paragraphs: ["Whole life insurance is coverage that lasts the rest of your life. As long as the premiums are paid in full, the policy is permanent and the death benefit is guaranteed.",
                        "A whole life policy not only lasts for the rest of your life, but it can also build cash value over time as you pay the premiums."],
                }
            ],
            image: "/product-landing/perm/circle2.png"
        },
        {
            text: [
                {
                    title: "What is lifetime protection?",
                    paragraphs: ["Lifetime protection is just that - insurance protection that lasts the rest of your life. As long as the premiums are paid, your coverage will never expire. This peace of mind can help cover expenses should something happen, as well as leave a legacy behind for your family."]
                }
            ],
            image: "/product-landing/perm/circle3.png"
        },
        {
            text: [
                {
                    title: "We find solutions that are the right fit for you",
                    paragraphs: ["With simplified issue whole life insurance, qualified applicants often receive a response within 10 minutes, and are not required to undergo a medical exam. This simple and efficient coverage provides a guaranteed death benefit so you can have peace of mind.",]
                }
            ],
            image: "/product-landing/perm/circle4.png"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Perm/MarketingData.js